import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React, {useState} from 'react'

import {i18n} from '../../config'
import {desktopClasses} from './Menu.classes'

type SubMenuProps = {
  isVisible?: boolean
}

function SubDeliveryMenuDeliveryToCustomer({
  isVisible = false,
}: SubMenuProps): React.ReactElement | null {
  return isVisible ? (
    <Grid alignItems="flex-start" container>
      <Grid container direction="column" item xs>
        <Grid item>
          <HeaderButton active size="s" transparent variant="pseudo">
            {i18n('order.header.link.around-town', 'По городу')}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton
            href="/express-delivery/"
            size="s"
            transparent
            variant="pseudo"
          >
            {i18n('order.header.link.one-hour-delivery', 'Доставка за час')}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton
            href="/next-day-delivery/"
            size="s"
            transparent
            variant="pseudo"
          >
            {i18n(
              'order.header.link.next-day-delivery',
              'Доставка на следующий день',
            )}
          </HeaderButton>
        </Grid>
        <Grid item>
          <HeaderButton
            href="/next-day-delivery/"
            size="s"
            transparent
            variant="pseudo"
          >
            {i18n('order.header.link.delivery-to-pvz', 'Доставка до ПВЗ')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid container direction="column" item xs>
        <Grid item xs>
          <HeaderButton active size="s" transparent variant="pseudo">
            {i18n('order.header.link.other-cities', 'В другие города')}
          </HeaderButton>
        </Grid>

        <Grid item xs>
          <HeaderButton
            href="/next-day-delivery/"
            size="s"
            transparent
            variant="pseudo"
          >
            {i18n('order.header.link.courier-delivery', 'Курьерская доставка')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton
            href="/next-day-delivery/"
            size="s"
            transparent
            variant="pseudo"
          >
            {i18n('order.header.link.delivery-to-pvs', 'Доставка до ПВЗ')}
          </HeaderButton>
        </Grid>
      </Grid>
    </Grid>
  ) : null
}

function SubDeliveryMenuB2BLogistic({
  isVisible = false,
}: SubMenuProps): React.ReactElement | null {
  return isVisible ? (
    <Grid container direction="column">
      <Grid item xs>
        <HeaderButton href="/magistral/" size="s" transparent variant="pseudo">
          {i18n('order.header.link.highways', 'Магистральные перевозки')}
        </HeaderButton>
      </Grid>
      <Grid item xs>
        <HeaderButton
          href="https://yandex.ru/routing/"
          size="s"
          target="_blank"
          transparent
          variant="pseudo"
        >
          {i18n('order.header.link.magistrals', 'Оптимизация ваших маршрутов')}
        </HeaderButton>
      </Grid>
    </Grid>
  ) : null
}

function ServicesMenu(): React.ReactElement {
  const [activeMenuItem, setActiveMenuItem] = useState<string>(
    'delivery-to-customer',
  )

  return (
    <Grid alignItems="flex-start" container>
      <Grid className={desktopClasses.servicesSubMenu} item>
        <Grid container direction="column">
          <Grid
            item
            onMouseEnter={() => {
              setActiveMenuItem('delivery-to-customer')
            }}
            xs
          >
            <HeaderButton
              active={activeMenuItem === 'delivery-to-customer'}
              transparent
              variant="pseudo"
            >
              {i18n(
                'order.header.link.delivery-to-buyer',
                'Доставка до покупателя',
              )}
            </HeaderButton>
          </Grid>
          <Grid
            item
            onMouseEnter={() => {
              setActiveMenuItem('b2b-delivery')
            }}
            xs
          >
            <HeaderButton
              active={activeMenuItem === 'b2b-delivery'}
              transparent
              variant="pseudo"
            >
              {i18n('order.header.link.b2b-delivery', 'B2B-Доставка')}
            </HeaderButton>
          </Grid>
          <Grid
            item
            onMouseEnter={() => {
              setActiveMenuItem('restaurant-delivery')
            }}
            xs
          >
            <HeaderButton
              active={activeMenuItem === 'restaurant-delivery'}
              href="/business/restaurants/"
              transparent
              variant="pseudo"
            >
              {i18n(
                'order.header.link.restaurant-delivery',
                'Доставка для ресторанов',
              )}
            </HeaderButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <SubDeliveryMenuDeliveryToCustomer
          isVisible={activeMenuItem === 'delivery-to-customer'}
        />
        <SubDeliveryMenuB2BLogistic
          isVisible={activeMenuItem === 'b2b-delivery'}
        />
      </Grid>
    </Grid>
  )
}

export default ServicesMenu
